import {
  BackupRestoreActionTypes,
  BackupRestoreState,
  FETCH_BACKUP_TASKS_FULFILLED,
  DELETE_BACKUP_FULFILLED,
  REQUEST_BACKUP_FILE_FULFILLED,
  BackupJobListResponseDTO,
  RESTORE_BACKUP_FILE_FULFILLED
} from './backup.types';

const initialState: BackupRestoreState = {
  backupFiles: [],
  tasks: {
    xcipioJobList: [],
    dxJobList: [],
    xcipioBackupFilesList: [],
    dxBackupFilesList: [],
    xcipioErrorMessage: '',
    dxErrorMessage: '',
  },
};

export default function backupReducer(
  state = initialState,
  action: BackupRestoreActionTypes
): BackupRestoreState {
  switch (action.type) {
    case FETCH_BACKUP_TASKS_FULFILLED:
      return {
        ...state,
        tasks: action.payload.data || {}
      };
    case REQUEST_BACKUP_FILE_FULFILLED: {
      const tasks: BackupJobListResponseDTO = { ...state.tasks };
      if (action.payload.data.xcipioJobList && action.payload.data.xcipioJobList.length > 0) {
        const currentXcipioJobList = state.tasks.xcipioJobList || [];
        tasks.xcipioJobList = [...currentXcipioJobList, action.payload.data.xcipioJobList[0]];
      }

      if (action.payload.data.dxJobList && action.payload.data.dxJobList.length > 0) {
        const currentDxJobList = state.tasks.dxJobList || [];
        tasks.dxJobList = [...currentDxJobList, action.payload.data.dxJobList[0]];
      }
      return {
        ...state,
        tasks
      };
    }
    case RESTORE_BACKUP_FILE_FULFILLED: {
      const tasks: BackupJobListResponseDTO = { ...state.tasks };
      if (action.payload.data.product === 'xcipio') {
        const currentXcipioJobList = state.tasks.xcipioJobList || [];
        tasks.xcipioJobList = [...currentXcipioJobList, { ...action.payload.data }];
      } else if (action.payload.data.product === 'discovery') {
        const currentDxJobList = state.tasks.dxJobList || [];
        tasks.dxJobList = [...currentDxJobList, { ...action.payload.data }];
      }
      return {
        ...state,
        tasks
      }
    }
    case DELETE_BACKUP_FULFILLED:
      return {
        ...state,
        backupFiles: action.payload.data.data || []
      };
    default:
      return state;
  }
}
